// Надписи, которые не вылезают за отведённое им место.
//
// Игра переведена на тридцать один язык, а длину переведённой надписи она не знает: ключ один,
// и «LAST WIN» на латышском выходит втрое длиннее английского, см. i18n/text.ts. Поэтому каждая
// надпись знает рамку, в которой стоит, и ужимается под неё, а не наезжает на соседа.
//
// Ужимается надпись масштабом узла, целиком со своей обводкой и разрядкой. Кегль для этого
// не годится: по нему Pixi пересобирает текстуру и заново переносит текст по словам, поэтому
// надпись меняла бы разбивку на строки от языка к языку.
//
// Ужимает игра только то, что не поместилось. Короткую надпись рамка не растягивает: кегль
// задаёт художник, и растянутое имя фичи спорило бы с остальным экраном.

import type { Text } from 'pixi.js';

/**
 * Рамка, в которой стоит надпись.
 *
 * Высота необязательна: однострочной надписи её задаёт кегль, и ужимать её по высоте нечем.
 */
export interface LabelRoom {
  readonly width: number;
  readonly height?: number;
}

/**
 * Во сколько раз ужать надпись, чтобы она встала в рамку.
 *
 * Надпись без размера не ужимается вовсе: пустая строка занимает нисколько, и делить нечего.
 */
export function fitScale(width: number, height: number, room: LabelRoom): number {
  if (width <= 0 || height <= 0)
    return 1;

  return Math.min(room.width / width, (room.height ?? Infinity) / height, 1);
}

/**
 * Ужимает надпись под её рамку.
 *
 * Прежний масштаб сбрасывается: та же надпись переписывается новым текстом, и мерить её надо
 * в своём размере, а не в том, до которого её ужал прошлый перевод.
 */
export function fitLabel(label: Text, room: LabelRoom): void {
  label.scale.set(1);
  label.scale.set(fitScale(label.width, label.height, room));
}
